import BadgesValue from "./BadgesValue";
import GeneralBadgesValue from "./GeneralBadgesValue";

export default class BadgesModel {
  public general: GeneralBadgesValue[] = [];
  public predictor: BadgesValue[] = [];
  public topX: BadgesValue[] = [];
  public matchQuiz: BadgesValue[] = [];
}
